export default {
  name: 'MNotification',
  props: {
    id: Number,
    icon: String,
    title: String,
    message: String,
    isReadable: {
      type: Boolean,
      default: false,
    },
    isAction: {
      type: Boolean,
      default: false,
    },
    action: {
      type: Object,
    },
  },
};
